<template>
  <div class="Header"
       ref="head">
    <div class="nav">
      <div class="container">
        <router-link to="/"
                     class="logobox">
          <img src="@/assets/logo.png"
               alt="">
        </router-link>
        <div class="rightBtn">
          <a href="http://zhuxue.net/mobile/"
             class="btn-lis">
            <img src="@/assets/zhongwen.png"
                 alt="">
          </a>
          <div class="btn-lis"
               @click="onShowMenu">
            <img src="@/assets/menu.png"
                 alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="blank"></div>
    <van-popup v-model="show"
               closeable
               position="right"
               :style="{ height: '100%' }">
      <div class="menu-nav">
        <div class="title">
          助学
        </div>
        <div>
          <van-collapse v-model="activeNames"
                        accordion>
            <van-collapse-item v-for="(item,index) in navlist"
                               :key="index"
                               :title="item.name"
                               :name="index">
              <a class="erLis"
                 :href="'/mobile'+item2.link"
                 v-for="(item2,index) in item.erLis"
                 :key="index">{{item2.name}}</a>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
    </van-popup>
  </div>
</template>


<script>
export default {
  name: 'Head',
  props: {
  },
  data () {
    return {
      navlist: [{
        name: '学校信息',
        link: '',
        erLis: [
          { name: '根据城市选择学院', link: '/school-list/1' },
          { name: '综合排名', link: '/school-list/0' },
          { name: '热门专业', link: '/school-list/1' },
          { name: '热门院校', link: '/school-list/2' }
        ]
      }, {
        name: '助学服务',
        link: '',
        erLis: [{
          name: '机场接送服务',
          link: '/jieji/2',
        }, {
          name: '大学申请服务',
          link: '/shenqing/0',
        }, {
          name: '住宿预定服务',
          link: '/zhusu/1',
        }, {
          name: '机场接机服务',
          link: '/jieji/2',
        }, {
          name: '签证服务',
          link: '/visa/3',
        }, {
          name: '论文核对服务',
          link: '/jiaodui/4',
        }, {
          name: '保险申请服务',
          link: '/baoxian/5',
        }, {
          name: '手机卡申请服务',
          link: '/SIM-Card/6',
        }
        ]
      }, {
        name: '教育中心',
        link: '',
        erLis: [{
          name: '中文培训中心',
          link: '/yuyan/0',
        }, {
          name: '考试准备中心',
          link: '/kaoshi/1',
        }, {
          name: '官方教材',
          link: '/jiaocai/2',
        },
        ]
      }, {
        name: '旅行生活',
        link: '',
        erLis: [{
          name: '生活中心',
          link: '/shenghuo/0',
        }, {
          name: '旅行中心',
          link: '/lvxing/1',
        }, {
          name: '求职中心',
          link: '/qiuzhi/2',
        }, {
          name: '反馈留言',
          link: '/fankui/3',
        }, {
          name: '常见问题',
          link: '/faq/4',
        }
        ]
      }, {
        name: '关于我们',
        link: '',
        erLis: [{
          name: '关于助学',
          link: '/about/0',
        }, {
          name: '我们的优势',
          link: '/about/1',
        }, {
          name: '合作伙伴',
          link: '/about/2',
        }, {
          name: '联系我们',
          link: '/about/3',
        }
        ]
      },
      ],
      show: false,
      activeNames: '',
    }
  },
  mounted () {
    this.$store.commit('update_navHeight', this.$refs.head.clientHeight + 15)
  },
  methods: {
    onShowMenu () {
      this.show = true
    }
  },
}
</script>

<style lang="scss" scoped>
.blank {
  height: 135px;
}
.nav {
  position: fixed;
  background-color: #fff;
  z-index: 999;
  top: 0;
  width: 100%;
  left: 0;
  // box-shadow: 0px 0px 8px rgba($color: #000000, $alpha: 0.2);
  box-shadow: none;
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
  }
}
.logobox {
  height: 80px;
  img {
    display: block;
    height: 100%;
  }
}
.rightBtn {
  display: flex;
}
.btn-lis {
  height: 60px;
  margin-left: 30px;
  img {
    display: block;
    height: 100%;
  }
}
.van-popup {
  .van-popup__close-icon {
    font-size: 50px;
  }
  .menu-nav {
    text-align: left;
    width: 400px;
    height: 100%;
    background-color: #fff;
    .title {
      padding: 30px;
      font-size: 36px;
    }
    .erLis {
      display: block;
      padding: 20px 0;
      color: #545454;
    }
  }
}
</style>